<script setup>
import {onMounted, ref} from "vue";
import CustomMask from "@/components/NewPC/CustomMask.vue";
import {showToast, showLoadingToast} from "vant";
import {sendMessageFun} from "@/api/common";
import QrcodeLogin from "@/components/NewPC/QrcodeLogin.vue";
import {appleInit, appleSignIn} from "@/utils/appleLogin";
import config from "@/config/config";
import {useTgaStore} from "@/store/tga";
import PrivacyAgreement from "@/components/NewPC/PrivacyAgreement.vue";
const phone = ref('');
const code = ref('');
const remember = ref(true); // 30天免登录
const agreement = ref(false); // 协议
const countdown = ref(0);
const countDownState = ref(false)
const CustomMaskRef = ref(null)
const tga = useTgaStore()

const errorStatus = ref(0);
const smsStatus = ref(0);

const QrcodeLoginRef = ref(null)
const PrivacyAgreementRef = ref(null)

const emits = defineEmits(['checkMessage', 'echoPlayerInfo']);

const open = () => {
  CustomMaskRef.value?.open();
}

// 发送短信
const sendMessage = () => {
  if (!phone.value) {
    showToast('请输入手机号码！')
    return
  }
  if (!/^1[3-9]\d{9}$/.test(phone.value)) {
    showToast('手机号格式不正确！')
    return
  }
  const loading = showLoadingToast({
    overlay: true,
    duration: 0,
    forbidClick: true
  });
  sendMessageFun(phone.value).then(res => {
    loading.close();
    if (res.status == 200 && res.data && res.data.code == 0) {
      showToast('发送成功')
      countDownState.value = true
      countdown.value = 60000;
      smsStatus.value = 1

      tga.tgaTrack('web_campaigns_event', {
        web_campaigns_op: 'pc_login',
        gps1: '获取验证码',
        gps2: "发送成功",
        gpn5: `${phone.value}`
      })
    } else {
      showToast(res.data.msg)
    }
  })
}

const checkMessage = () => {
  if (!phone.value) {
    showToast('请输入手机号码！')
    return
  }
  if (!/^1[3-9]\d{9}$/.test(phone.value)) {
    showToast('手机号格式不正确！')
    return
  }
  if (!code.value) {
    showToast('请输入短信验证码！')
    return
  }
  if (smsStatus.value != 1) {
    showToast('请先获取验证码！')
    return
  }
  if (!agreement.value) {
    showToast('请先勾选同意《街球艺术玩家隐私政策协议》')
    errorStatus.value = 1
    return
  }
  localStorage.setItem('WEBSITE_LOGIN_REMEMBER', JSON.stringify(remember.value));
  emits('checkMessage', {phone:phone.value, code:code.value, remember: remember.value})
}

const handleShowQrcodeLogin = type => {
  if (!agreement.value) {
    showToast('请先勾选同意《街球艺术玩家隐私政策协议》')
    errorStatus.value = 1
    return
  }
  localStorage.setItem('WEBSITE_LOGIN_REMEMBER', JSON.stringify(remember.value));
  if (type == 2) {
    const loading = showLoadingToast({
      overlay: true,
      duration: 0,
      forbidClick: true
    })
    tga.tgaTrack('web_campaigns_event', {
      web_campaigns_op: 'pc_login',
      gps1: '点击Apple登录',
    })
    appleSignIn(
        "com.racoondigi.web.jqys",
        `${config.appleCallback}/officialWebsite/login`
    ).then((res) => {
      if (res.status == 200 && res.data && res.data.code == 0) {
        emits('echoPlayerInfo', {playerInfo:res.data.playerInfo, token: res.data.data});
        tga.tgaTrack('web_campaigns_event', {
          web_campaigns_op: 'pc_login',
          account: res.data.playerInfo.account,
          gps1: '点击Apple登录',
          gps2: '成功',
        })
        loading.close()
      } else {
        loading.close()
        showToast(res.data.msg)
        tga.tgaTrack('web_campaigns_event', {
          web_campaigns_op: 'pc_login',
          gps1: '点击Apple登录',
          gps2: '失败',
          gps3: res.data.msg
        })
      }
    }).catch((error) => {
      console.log(error)
      loading.close()
    })
  } else {
    QrcodeLoginRef.value?.open(true);
    tga.tgaTrack('web_campaigns_event', {
      web_campaigns_op: 'pc_login',
      gps1: '点击微信登录',
    })
    open();
  }
}
onMounted(() => {
  appleInit(
      "com.racoondigi.web.jqys",
      `${config.appleCallback}/officialWebsite/login`
  )
})
defineExpose({open})
</script>

<template>
<custom-mask ref="CustomMaskRef" @click="open">
  <div class="phone_dialog" @click.stop>
    <img src="@/assets/newPc/topup/login_dialog_close.png" alt="" @click="open" class="close_icon">
    <div class="title">请先登录您的账号</div>
    <div class="subtitle">手机号登录</div>
    <div>
      <input v-model="phone" placeholder="请输入手机号码" />
    </div>
    <div class="input_block">
      <input v-model="code" maxlength="6" placeholder="请输入短信验证码" />
      <div>
        <van-count-down class="down_text" v-if="countDownState" :time="countdown" format="ss" @finish="countDownState = false" />
        <span v-else @click="sendMessage">点击发送</span>
      </div>
    </div>
    <div class="radio_row">
      <img @click="remember = !remember" v-if="!remember" src="@/assets/newPc/topup/radio_icon_default.png" alt="">
      <img @click="remember = !remember" v-else src="@/assets/newPc/topup/radio_icon_check.png" alt="">
      <span @click="remember = !remember">30天免登录</span>
    </div>
    <div class="radio_row">
      <img @click="agreement = !agreement" v-if="!agreement" src="@/assets/newPc/topup/radio_icon_default.png" alt="">
      <img @click="agreement = !agreement" v-else src="@/assets/newPc/topup/radio_icon_check.png" alt="">
      <span @click="agreement = !agreement" :class="{'error_color': errorStatus == 1}">我已详细阅读并同意</span>
      <span class="agreement" @click="PrivacyAgreementRef.open()">《街球艺术玩家隐私政策》</span>
    </div>
    <van-button type="primary" class="login_btn" @click="checkMessage">登录</van-button>

    <van-divider dashed class="divider">更多登录方式</van-divider>

    <div class="other_method">
      <img src="@/assets/newPc/topup/applet_icon.png" @click="handleShowQrcodeLogin(2)" alt="">
      <img src="@/assets/newPc/topup/wechat_icon.png" @click="handleShowQrcodeLogin(1)" alt="">
    </div>
  </div>
</custom-mask>
<QrcodeLogin ref="QrcodeLoginRef" @echo-player-info="data => emits('echoPlayerInfo', data)" />
<privacy-agreement ref="PrivacyAgreementRef" />
</template>

<style scoped lang="scss">

.phone_dialog {
  margin: auto;
  width: 24.1015625vw;
  height: 30.3515625vw;
  box-sizing: border-box;
  position: relative;

  background: transparent url("@/assets/newPc/topup/login_dialog_bg.png") no-repeat center center;
  background-size: contain;

  .close_icon {
    width: 1.5625vw;
    height: 1.5625vw;
    position: absolute;
    top: 1.3671875vw;
    right: 1.2890625vw;
    cursor: pointer;
  }

  .title {
    color: #FF9120;
    text-align: center;
    padding-top: 1.8359375vw;
    margin-bottom: 1.25vw;
    line-height: 1;
    font-size: 1.171875vw;
  }

  .subtitle {
    color: #6B6660;
    font-size: 1.015625vw;
    line-height: 1;
    text-align: center;
  }

  input {
    width: 18.75vw;
    height: 2.34375vw;
    display: block;
    background-color: #fff;
    border-color: #ACACAC;
    padding: 0 0.7421875vw;
    margin: 1.015625vw auto 1.328125vw;
    box-sizing: border-box;
    font-size: 0.78125vw;
  }
  .input_block {
    position: relative;
    width: 18.75vw;
    margin: auto;

    div {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      width: 4.8828125vw;
      height: 2.34375vw;
      color: #FF9020;
      font-size: 0.78125vw;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        cursor: pointer;
      }

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0.625vw;
        height: 1.0546875vw;
        width: 0.078125vw;
        background-color: #ACACAC;
      }
      .down_text {
        color: #ACACAC;
      }
    }
  }

  .radio_row {
    color: #6B6660;
    font-size: 0.78125vw;
    margin-bottom: 0.3515625vw;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 3.0859375vw;
    line-height: 1;

    &:last-child {
      margin-bottom: 0;
    }

    img {
      width: 0.859375vw;
      height: 0.859375vw;
      margin-right: 0.1953125vw;
      cursor: pointer;
    }

    span {
      cursor: pointer;
    }

    .agreement {
      color: #FF9120;
    }
  }

  .divider {
    width: 18.75vw;
    margin: 2.96875vw auto 0;
    color: #6B6660;
    font-size: 0.78125vw;
    line-height: 1;
  }

  .login_btn {
    width: 18.75vw;
    height: 2.4609375vw;
    margin: 2.3828125vw auto 0;
    display: block;
    background: linear-gradient(to right, #FF3FB0, #FF274F);
    border-color: #fff;
  }

  .other_method {
    width: 18.75vw;
    margin: 1.015625vw auto 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    img {
      width: 2.578125vw;
      height: 2.578125vw;
      margin-right: 1.5625vw;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.error_color {
  color: red !important;
}
</style>